import { createContext } from 'react';
import { IAuthContext } from '../interfaces/authInterface';

const AuthContext = createContext<IAuthContext>(null!);
export default AuthContext;
